import React from 'react'
import { navigate } from '@reach/router'
import { useGlobal } from './GlobalContext'
import { isEmptyObject } from '../utils/helpers/helpers'
import { listaInfosPagamento } from '../api/pagamento.servico'
import { cadastraCartao } from '../api/cartaoCredito.servico'
import { getPix } from '../api/pix.servico'
import { getVendasPorAssinatura } from '../api/assinatura.servico'

const PixContext = React.createContext()

function PixProvider( props ) {
  const [ state, setState ] = React.useState( {
    'codigoPix': null,
    'infosPagamento': {},
    'urlQrCode': null
  } )

  const value = React.useMemo(
    () => {
      return {
        setState,
        state
      }
    },
    [ state ]
  )

  return (
    <PixContext.Provider
      value={ value }
      { ...props }
    />
  )
}

function usePix() {
  const context = React.useContext( PixContext )
  const { modalidadeURL, setErroRequisicao } = useGlobal()

  if ( !context ) {
    throw new Error( 'usePix deve ser usado dentro de PixProvider' )
  }

  const { state, setState } = context

  const setInfosPagamento = infosPagamento => {
    setState( ( prevState ) => ( {
      ...prevState,
      infosPagamento
    } ) )
  }

  const setCodigoPix = codigoPix => {
    setState( ( prevState ) => ( {
      ...prevState,
      codigoPix
    } ) )
  }

  const setUrlQrCode = urlQrCode => {
    setState( ( prevState ) => ( {
      ...prevState,
      urlQrCode
    } ) )
  }

  const getInfosPagamento = async( idAssinatura ) => {
    try {
      const infosPagamentoResponse = await listaInfosPagamento( idAssinatura )
      const [ infosPagamentoUltimaVenda ] = await getVendasPorAssinatura( idAssinatura )
      if ( !isEmptyObject( infosPagamentoResponse.data ) && !isEmptyObject( infosPagamentoUltimaVenda ) ) {
        const infosPagamento = infosPagamentoResponse.data
        const valorLiquidoSemDesconto = Number( infosPagamentoUltimaVenda.valor_bruto ) + Number( infosPagamentoUltimaVenda.valor_frete )
        const totalDescontos = Number( infosPagamentoUltimaVenda.desconto_geral ) + Number( infosPagamentoUltimaVenda.desconto_frete ) + Number( infosPagamentoUltimaVenda.desconto_kit )
        infosPagamento.valorFrete = Number( infosPagamentoUltimaVenda.valor_frete )
        infosPagamento.valorLiquido = valorLiquidoSemDesconto - totalDescontos
        infosPagamento.parcelas = infosPagamentoUltimaVenda.parcelas

        setInfosPagamento( infosPagamento )
      }
    } catch ( erro ) {
      setErroRequisicao( erro.response.status )
    }
  }

  const getInfoPix = async idAssinatura => {
    try {
      const response = await getPix( idAssinatura )
      if ( !isEmptyObject( response.data ) ) {
        setCodigoPix( response.data.assinatura.pagamento.pix.dados )
        setUrlQrCode( response.data.assinatura.pagamento.pix.url )
      }
    } catch ( erro ) {
      setErroRequisicao( erro.response.status )
    }
  }

  const trocarFormaPagamento = async( cartao, idAssinatura ) => {
    const dados = {
      'assinatura': idAssinatura,
      'cartao_credito': { ...cartao }
    }

    try {
      const response = await cadastraCartao( dados )
      if ( response ) {
        navigate( `${modalidadeURL}/pagamento` )
      }
    } catch ( erro ) {
      const { message } = erro.response.data.errors[ 0 ] || null
      if ( message ) {
        const descricaoErro = {
          'descricao': message,
          'titulo': 'Houve um erro!'
        }
        setErroRequisicao(
          erro.response.status || erro.request.status,
          descricaoErro
        )
      } else {
        setErroRequisicao( erro.response.status )
      }
    }
  }

  return {
    'codigoPix': state.codigoPix,
    getInfosPagamento,
    'getPix': getInfoPix,
    'infosPagamento': state.infosPagamento,
    trocarFormaPagamento,
    'urlQrCode': state.urlQrCode
  }
}

export { PixProvider, usePix }
